export function request (params) {
  return {
    dollarVolume: 100000,
    securities: 200000,
    shareVolume: 300000,
    trades: 400000
  }
}
